import parsePhoneNumberFromString from "libphonenumber-js";

class Validator {
    static ERRORS = {
        required: "Veuillez remplir ce champs.",
        email: "Veuillez entrer une adresse email valide.",
        phone: "Veuillez entrer un numéro de téléphone (avec indicatif) valide.",
        number: "Veuillez entrer un nombre valide.",
        checkbox: "Veuillez cocher cette case."
    };

    static validate(form, fieldData) {
        const errors = {};
        let hasErrors = false;
        for (let data in fieldData) {
            const field = form[data];
            const fieldValidation = Validator.validateField(field, data, fieldData[data].required, fieldData[data].type);

            errors[data] = fieldValidation;
            if (fieldValidation) {hasErrors = true}
        }

        errors.hasErrors = hasErrors;
        return errors;
    }

    static validateField(field, name, required, type) {
        let error = null;

        if (required && ((field === null || field.length === 0))) {
            error = this.ERRORS.required;
        } else if (!(field === null || field.length === 0)) {
            if (type === "email") {
                if (!Validator.email(field)) {
                    error = this.ERRORS.email;
                }
            }
            if (type === "phone") {
                if (!Validator.phone(field)) {
                    error = this.ERRORS.phone;
                }
            }
            if (type === "number") {
                if (!Validator.number(field)) {
                    error = this.ERRORS.number;
                }
            }
            if(required && (type === "checkbox" && field === false)){
                error = this.ERRORS.checkbox;
            }
        }

        return error;
    }

    static email(email) {
        return String(email)
            .toLowerCase()
            .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );
    }

    static phone(phone) {
        return parsePhoneNumberFromString(phone)?.isValid();
    }

    static number(number) {
        return !isNaN(number);
    }
}

export default Validator;